import React from 'react';
import { LayoutDashboardIcon, BotIcon, UsersIcon, ShieldCheckIcon, TrendingUpIcon, MessageCircleIcon, AlertTriangleIcon, HeartHandshakeIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-275">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-276">
        <div className="text-center mb-16" data-id="element-277">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-278">
            Everything Your Family Needs in One Place
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-279">
            No more juggling apps, Googling fixes, or explaining the same thing
            twice. Caveo brings it all together.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-280">
          {/* Family Dashboard */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-281">
            <div className="flex items-center mb-6" data-id="element-282">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-283">
                <LayoutDashboardIcon className="w-6 h-6 text-[#631bb7]" data-id="element-284" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-285">
                The Family Dashboard
              </h3>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-286">
              A unified view of your entire family's security posture. See
              everyone's progress at a glance.
            </p>
            <div className="space-y-4" data-id="element-287">
              <div className="flex items-start" data-id="element-288">
                <TrendingUpIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-289" />
                <div data-id="element-290">
                  <span className="font-semibold text-[#111111]" data-id="element-291">
                    Family Security Score
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-292">
                    See your family's overall protection level
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-293">
                <UsersIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-294" />
                <div data-id="element-295">
                  <span className="font-semibold text-[#111111]" data-id="element-296">
                    Individual Progress
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-297">
                    Track each family member's learning journey
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-298">
                <ShieldCheckIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-299" />
                <div data-id="element-300">
                  <span className="font-semibold text-[#111111]" data-id="element-301">
                    Coordinated Protection
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-302">
                    Shared guides prevent costly mistakes
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* AI Security Coach */}
          <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-303">
            <div className="flex items-center mb-6" data-id="element-304">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-305">
                <BotIcon className="w-6 h-6 text-[#631bb7]" data-id="element-306" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-307">
                Your Security Coach
              </h3>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-308">
              Patient, brilliant, and kind — like Mr. Rogers meets an Apple
              Genius.
            </p>
            <div className="space-y-4" data-id="element-309">
              <div className="flex items-start" data-id="element-310">
                <MessageCircleIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-311" />
                <div data-id="element-312">
                  <span className="font-semibold text-[#111111]" data-id="element-313">
                    Plain English Help
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-314">
                    No jargon, just practical guidance
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-315">
                <AlertTriangleIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-316" />
                <div data-id="element-317">
                  <span className="font-semibold text-[#111111]" data-id="element-318">
                    Proactive Alerts
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-319">
                    Identifies issues before they become problems
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-320">
                <HeartHandshakeIcon className="w-5 h-5 text-[#631bb7] mr-3 mt-0.5 flex-shrink-0" data-id="element-321" />
                <div data-id="element-322">
                  <span className="font-semibold text-[#111111]" data-id="element-323">
                    Human Support
                  </span>
                  <p className="text-sm text-gray-600" data-id="element-324">
                    Real people when you need them
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Learning Center Preview */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-325">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8" data-id="element-326">
            <div data-id="element-327">
              <h3 className="text-2xl font-bold text-[#111111] mb-2" data-id="element-328">
                The Learning Center
              </h3>
              <p className="text-gray-600" data-id="element-329">
                39 educational modules across three skill levels
              </p>
            </div>
            <a href="/learning-center" className="mt-4 md:mt-0 text-[#631bb7] font-semibold hover:underline" data-id="element-330">
              Explore All Modules →
            </a>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-331">
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-332">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-333">
                LEVEL 1 • ESSENTIALS
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-334">
                9 Modules
              </div>
              <p className="text-sm text-gray-600" data-id="element-335">
                Passwords, Scams & Phishing, and more
              </p>
            </div>
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-336">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-337">
                LEVEL 2 • INTERMEDIATE
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-338">
                11 Modules
              </div>
              <p className="text-sm text-gray-600" data-id="element-339">
                Financial Accounts, Cloud Storage, and more
              </p>
            </div>
            <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-340">
              <div className="text-sm font-bold text-[#631bb7] mb-2" data-id="element-341">
                SPECIALIZED GUIDES
              </div>
              <div className="text-3xl font-bold text-[#111111] mb-2" data-id="element-342">
                19 Deep Dives
              </div>
              <p className="text-sm text-gray-600" data-id="element-343">
                AI Primer, Digital Legacy, and more
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}